<template>
  <div>
    <title-menu
            :icon="'fad fa-boxes'"
            :id="'products'"
            :title="product.name"
            class="m-show-flex-xl"
            v-if="product"
    >
      <template slot="menu">
        <a
                :class="{ 'active': activeIndex === 'general' }"
                @click="activeLink('general')"
                href="javascript:">
          General
        </a>
        <div class="dropdown-divider"></div>
        <h6 class="dropdown-header">Workflows</h6>
        <template v-for="(id, index) in productCopy.workflows">
          <a
                  :class="{ 'active': activeIndex === index }"
                  :key="index"
                  @click="activeLink(id, index)"
                  href="javascript:"
                  v-if="id.length"
          >
            {{getWorkflowName(id)}}
          </a>
        </template>
      </template>
    </title-menu>
    <div class="row">
      <div class="col-2 list-menu-block m-hide-xl">
        <ul v-if="product">
          <li
                  :class="{ 'active': activeIndex === 'general' }"
                  @click="activeLink('general')">
            General
          </li>
          <template v-for="(id, index) in productCopy.workflows">
            <li
                    :class="{ 'active': activeIndex === index }"
                    :key="index"
                    @click="activeLink(id, index)"
                    v-if="id.length"
            >
              {{getWorkflowName(id)}}
            </li>
          </template>
        </ul>
      </div>
      <div class="col-xl-10" v-if="product">
        <transition name="fade">
          <component
                  :documentId="id"
                  :is="dynamicProduct"
                  :product="product"
                  :workflowId="editWorkflowId"
                  @productSaved="fetchProductData($event)"
                  @resetValue="resetValues($event)"
                  @unsavedChanges="hasUnsavedChanges($event)"
                  v-if="product && renderedComponent"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import ProductGeneral from '../../components/product/ProductGeneral';
  import ProductWorkflowUnits from '../../components/product/ProductWorkflowUnits';
  import {renderComponent} from '../../mixins/renderComponent';
  import TitleMenu from '../../components/general/TitleMenu';

  // @vuese
  // @group Products
  // Shows product details and allows editing
  export default {
    name: 'ProductDetails',
    components: {
      ProductGeneral,
      ProductWorkflowUnits,
      TitleMenu
    },
    props: {
      // @vuese
      //  The id of the product shown
      id: {
        required: true,
        type: Number

      }
    },
    mixins: [renderComponent],
    data() {
      return {
        disableNavigation: false,
        disableNavigationChild: false,
        dynamicProduct: 'product-general',
        productGeneral: true,
        product: null,
        productBackup: null,
        productCopy: null,
        editWorkflowId: null,
        activeIndex: 'general'
      };
    },
    computed: {
      ...mapGetters('products', [
        'getProduct'
      ]),
      ...mapGetters('workflows', [
        'getWorkflowName'
      ])
    },
    methods: {
      /**
       * @vuese
       * Event hasUnsavedChanges, when triggered set disableNavigation to true or false
       * @param event
       */
      hasUnsavedChanges(event) {
        this.disableNavigation = event;
      },

      /**
       * @vuese
       * Reset value when switching between tabs (Workflows)
       * otherwise changed data will still be visible after navigating back
       * @arg `productBackup`
       */
      resetValues(productBackup) {
        this.productBackup = productBackup;
      },

      /**
       * @vuese
       * Switching between tabs (general or Workflows) and the desired component
       * @arg `id`
       * @arg `index`
       */
      navigateComponent(id, index) {
        if(id === 'general') {
          this.dynamicProduct = 'product-general';
          this.activeIndex = 'general';
          this.product = this.productBackup;
        } else {
          this.dynamicProduct = 'product-workflow-units';
          this.activeIndex = index;
        }
        this.editWorkflowId = id;
        this.renderComponent();
      },

      /**
       * @vuese
       * Add styling to the active Tab
       * @arg `id`
       * @arg `index`
       */
      activeLink(id, index) {
        if(this.disableNavigation) {
          this.swalUnsavedChanges().then(result => {
            if(result.value) {
              this.navigateComponent(id, index);
              this.renderComponent();
            }
          });
        } else {
          this.navigateComponent(id, index);
          this.renderComponent();
        }
      },

      /**
       * @vuese
       * Fetching product data and making a copy for unsaved changes functionality
       * @arg `response`
       */
      fetchProductData(response) {
        let productData = this.getProduct(this.id);
        let jsonParseProduct = JSON.parse(JSON.stringify(productData));
        this.product = jsonParseProduct;
        this.productCopy = jsonParseProduct;
        if(response) {
          this.hasUnsavedChanges(response.unsavedChanges);
        }
      }
    },
    created() {
      this.fetchProductData();
      this.productBackup = this.product;
    }
  };
</script>
